import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { RedirectError } from '@/errors/RedirectError';
import {
  APP_STATE_STORAGE_KEY,
  APP_STORAGE_KEY,
  REDEEM_STORAGE_KEY,
} from '@/components/AccessCodeRedemptionDialog/access-code-deep-link';

export function ErrorBoundary() {
  const error = useRouteError() as Error;

  console.error(error);
  if (error instanceof RedirectError) {
    sessionStorage.removeItem(APP_STORAGE_KEY);
    sessionStorage.removeItem(APP_STATE_STORAGE_KEY);
    sessionStorage.removeItem(REDEEM_STORAGE_KEY);
    window.location.href = error.cause as string;
    return null;
  }
  if (isRouteErrorResponse(error)) {
    const data = error.data as { message?: string };
    return (
      <>
        <h1>Oops, something went wrong!</h1>
        <h2>{error.status}</h2>
        <p>{error.statusText}</p>
        {data?.message && <p>{data.message}</p>}
      </>
    );
  }

  return (
    <>
      <h1>Oops, something went wrong!</h1>
      <p>{error.message}</p>
    </>
  );
}
